module.exports = __webpack_public_path__ + "static/media/received_1517480094933157.c3f26693.jpg";